<template>
  <el-form class="arrive-scene" label-width="120px">
    <el-form-item v-show="form.verifyType" label="下一步">
      <el-select v-model="form.nextstep">
        <el-option v-for="(step,index) of nextStepList" :key="`stepInfo-${index}`" :value="step.nodeId"
          :label="step.nodeName"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="备注">
      <el-input type="textarea" v-model="form.description">
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button size="small" type="primary" @click="onSubmit">确认</el-button>
      <el-button size="small" @click="onCancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import {
  getNextStepInfo,
  auditOrder,
} from '@/api/equipment-operational/index';
import { convertDataToFormData } from '@/utils/utils';
import DiaFormMixin from '@/components/operating-maintenance/mixins/dia-form-mixin';

export default {
  name: 'arrive-sence',
  mixins: [DiaFormMixin],
  props: {
    selectProcessInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {
        taskId: null,
        verifyType: true,
        nextstep: '',
      },
      userinfo: {},
      nextStepList: [],
    };
  },
  created() {
    this.userinfo = JSON.parse(localStorage.getItem('userInfo'));
    this.initialFormData();
    this.requestNextStepList();
    console.log('登录用户', this.userinfo);
  },
  onload() {

  },
  watch: {
    selectProcessInfo() {
      this.initialFormData();
      this.requestNextStepList();
    },
  },
  methods: {
    // 初始化表单数据
    initialFormData() {
      this.form.taskId = this.selectProcessInfo.F_TaskId;
    },
    onSubmit() {
      this.submitAudit();
    },
    onCancel() {
      this.emitCloseDialog();
    },
    submitAudit() {
      if (this.userinfo == null || this.userinfo == undefined || this.userinfo == '') {
        this.$message.warning('获取不到用户信息,请重新登录');
        return;
      }
      this.formatForm();
      const formData = convertDataToFormData(this.form);
      auditOrder(formData).then(() => {
        this.notifyDataChanged();
        this.emitCloseDialog();
      });
    },
    formatForm() {
      const auditers = [];
      const obj = {};
      obj[this.form.nextstep] = {
        userId: this.userinfo.UserId,
        userName: this.userinfo.UserName,
      };
      auditers.push(obj);
      this.form.auditers = JSON.stringify(auditers);
      console.log('54685748574574654', this.form.auditers);

      // 审核结果 转换 （1、通过；2、拒绝）
      if (this.form.verifyType) {
        this.form.verifyType = 1;
      } else {
        this.form.verifyType = 2;
      }
    },
    requestNextStepList() {
      if (this.selectProcessInfo == null) {
        return;
      }
      getNextStepInfo({
        isNew: false,
        processId: this.selectProcessInfo.F_Id,
        schemeCode: this.selectProcessInfo.F_SchemeCode,
        taskId: this.selectProcessInfo.F_TaskId,
        formData: '',
      }).then((res) => {
        this.nextStepList = res;
        const [nextStep] = res;
        this.$set(this.form, 'nextstep', nextStep.nodeId);
        // this.form.auditers = [{
        //   [nextStep.nodeId]: {
        //     userId: nextStep.id,
        //     userName: nextStep.text,
        //   },
        // }];
      });
    },
  },
};
</script>
<style scoped>

</style>
